import { Directive, ElementRef, HostListener, Injector, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Directive()
export class FiContenteditableBase extends ControlValueAccessorValidatorBase<string> implements OnChanges {
    @Input() required: boolean;
    protected elRef: ElementRef<HTMLElement>;
    private lastViewModel: string;

    constructor(protected injector: Injector) {
        super(injector);

        this.elRef = this.injector.get(ElementRef);
    }

    protected checkContentChange() {
        const innerHtml = this.elRef.nativeElement.innerHTML;
        if (this.lastViewModel !== innerHtml) {
            this.ngModel = this.lastViewModel = this.elRef.nativeElement.innerHTML;
            this.doPropagateChanges();
        }
    }

    @HostListener('blur')
    elementOnBlur() {
        this.checkCleanHTML();
        this.checkContentChange();
    }

    @HostListener('keypress')
    onKeypress() {
        this.checkContentChange();
    }

    @HostListener('change')
    onChange() {
        this.checkContentChange();
    }

    @HostListener('paste', ['$event'])
    onPaste($event) {
        this.checkContentChange();
    }

    checkCleanHTML() {
        const el = this.elRef.nativeElement;
        if (
            (el.innerText.trim().length === 0 || el.innerText.match(/^\s+$/)) &&
            el.querySelectorAll('img').length === 0 &&
            el.querySelectorAll('video').length === 0 &&
            el.querySelectorAll('iframe').length === 0 &&
            el.querySelectorAll('table').length === 0
        ) {
            el.innerText = '';
        }
    }

    @HostListener('keyup', ['$event'])
    protected onKeyup($event) {
        this.checkContentChange();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.ngModel && changes.ngModel.currentValue !== this.lastViewModel) {
            this.lastViewModel = changes.ngModel.currentValue;
            this.refreshView();
        }
    }

    protected refreshView() {
        this.elRef.nativeElement.innerHTML = this.ngModel || '';
    }
}
